import { width } from '../shared/width-informer';
const T_STAGGER = 't-stagger';
export default class Iphone {
  constructor(itemSelector) {
    this.collection = document.querySelectorAll(itemSelector);
    this.tl = null;
  }

  init() {
    if (!this.check()) {
      return;
    }
    if (width() < 1024) {
      this.clearStagger();
      return;
    }

    this.main();
  }

  clearStagger() {
    this.collection.forEach(iphone => {
      iphone.classList.remove(T_STAGGER);
    });
  }

  check() {
    if (!this.collection.length > 0) {
      return;
    }

    return true;
  }

  main() {
    this.tl = new TimelineMax({ paused: true });

    this.tl.staggerFromTo(
      this.collection,
      0.4,
      { y: '3px', autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power1.easeOut },
      0.2
    );
  }

  play() {
    this.tl.play();
  }
}
